import React from 'react';
import { motion } from 'framer-motion';
import BufferingLoader from '../../pages/HomePage/IntentSignals/components/BufferingLoader';

const PageLoader: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm"
    >
      <div className="flex flex-col items-center gap-4">
        <BufferingLoader />
        <p className="text-[16px] text-[#222D49] font-light">Loading...</p>
      </div>
    </motion.div>
  );
};

export default PageLoader; 